var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAppointment24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.833 9.167H7.5v1.666H5.833V9.167zm0 3.333H7.5v1.667H5.833V12.5zm3.334-3.333h1.666v1.666H9.167V9.167zm0 3.333h1.666v1.667H9.167V12.5zM12.5 9.167h1.667v1.666H12.5V9.167zm0 3.333h1.667v1.667H12.5V12.5z",
    transform: "translate(-24 -120) translate(0 70) translate(24 50)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.167 18.333h11.666c.92 0 1.667-.747 1.667-1.666V5c0-.92-.747-1.667-1.667-1.667h-1.666V1.667H12.5v1.666h-5V1.667H5.833v1.666H4.167C3.247 3.333 2.5 4.081 2.5 5v11.667c0 .919.748 1.666 1.667 1.666zM15.833 6.667l.001 10H4.167v-10h11.666z",
    transform: "translate(-24 -120) translate(0 70) translate(24 50)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAppointment24);
export default __webpack_public_path__ + "static/media/ic-appointment-24.98384954.svg";
export { ForwardRef as ReactComponent };